<template>
  <div class="flex items-center mt-2 ml-2 range-selector">
    <button
      type="button"
      :aria-label="t('tts.settings.decreaseRangeValue')"
      :title="t('tts.settings.decreaseRangeValue')"
      :disabled="checkDisabled('decrease') ? true : false"
      class="square-selector flex items-center justify-center"
      :class="checkDisabled('decrease') ? 'button-disabled' : null"
      @click="handleReduce"
    >
      <span class="material-icons" aria-hidden="true">
        {{ decreaseIcon }}
      </span>
    </button>
    <span class="mx-4 flex flex-1 justify-center"> {{ rangeValue }}x </span>
    <button
      type="button"
      :aria-label="t('tts.settings.increaseRangeValue')"
      :title="t('tts.settings.increaseRangeValue')"
      :disabled="checkDisabled('increase') ? true : false"
      class="square-selector flex items-center justify-center"
      :class="checkDisabled('increase') ? 'button-disabled' : null"
      @click="handleIncrease"
    >
      <span class="material-icons" aria-hidden="true">
        {{ increaseIcon }}
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  rangeValue: {
    type: Number,
    default: 1,
  },
  minValue: {
    type: Number,
    default: 1,
  },
  maxValue: {
    type: Number,
    default: 100,
  },
  step: {
    type: Number,
    default: 1,
  },
  decreaseIcon: {
    type: String,
    default: "remove",
  },
  increaseIcon: {
    type: String,
    default: "add",
  },
});

const emit = defineEmits<{
  (e: "rangeSelectorChanged", newRangeValue: number): void;
}>();

function handleReduce(e: Event): void {
  e.preventDefault();
  const newValue = props.rangeValue - props.step;
  emit("rangeSelectorChanged", Number(newValue.toFixed(1)));
}

function handleIncrease(e: Event): void {
  e.preventDefault();
  const newValue = props.rangeValue + props.step;
  emit("rangeSelectorChanged", Number(newValue.toFixed(1)));
}

function checkDisabled(button: string): boolean {
  if (button === "decrease" && props.rangeValue <= props.minValue) return true;
  if (button === "increase" && props.rangeValue >= props.maxValue) return true;
  return false;
}
</script>

<style lang="scss" scoped>
@use "@/assets/styles/reader.scss" as *;

.range-selector {
  width: 100%;
  max-width: 15rem;
}
.square-selector {
  width: 4rem;
  height: 3rem;
  border-radius: $spacingXS;
  border: $spacingXS solid var(--DM__theme-hover-color);
  transition: all 0.1s ease;

  @media (any-hover: hover) {
    &:hover {
      border-color: var(--DM__theme-slider-color);
      background-color: var(--DM__theme-hover-color);
    }
  }

  &:focus {
    border-color: var(--DM__theme-border-color);
    outline: 0;
    &:not(:focus-visible) {
      border-color: var(--DM__theme-slider-color);
    }
  }

  &.button-disabled {
    color: var(--DM__color-grisFonce);
    opacity: 0.7;
    border-color: var(--DM__color-grisFonce);
    background-color: var(--DM__color-fill);
    cursor: not-allowed;
    @media (any-hover: hover) {
      &:hover {
        border-color: var(--DM__color-grisFonce);
        background-color: var(--DM__color-fill);
      }
    }
  }
}
</style>
